import { render } from "./QueueManage.vue?vue&type=template&id=602a65e3&scoped=true"
import script from "./QueueManage.vue?vue&type=script&lang=ts"
export * from "./QueueManage.vue?vue&type=script&lang=ts"

import "./QueueManage.vue?vue&type=style&index=0&id=602a65e3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-602a65e3"

export default script